import React, { useEffect, useRef, useState } from "react";
import {
  ClickAwayListener,
  Divider,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import { ToolBarMenu } from "Constants/ToolBarMenu";
import Translator from "Languages/Utility/Translator";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as Icons from "react-bootstrap-icons";
import { push } from "Helpers/History";
import { logout } from "Stores/actions";
import { read } from "Helpers/LocalStorage";

export default function DashboardToolbarMenu({ rtlLayout, setReload }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);
  const [infoOpen, setInfoOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [toolbar, setToolBar] = useState(null);
  const { userData, notificationCount } = useSelector((state) => ({
    userData: state.auth.userData,
    notificationCount: state.notification.notificationCount,
  }));
  const anchorRef = useRef(null);
  const anchorRef2 = useRef(null);

  useEffect(() => {
    if (userData) {
      setLoading(false);
      let _toolbar = ToolBarMenu;
      _toolbar.dashboard[1].authorize =
        read("StypeU") === "1" && !userData?.panel?.isFree;
      _toolbar.dashboard[3].authorize = read("StypeU") === "1";
      _toolbar.dashboard[7].authorize =
        read("StypeU") === "1" && userData?.panel?.isFree;
      _toolbar.dashboard[1].disabled = !userData?.panel?.isFree;
      _toolbar.dashboard[7].disabled = userData?.panel?.isFree;
      _toolbar.dashboard[4].authorize =
        read("settingConstructRules") ||
        read("settingDesignerRules") ||
        read("settingFactorRules");
      _toolbar.design[3].authorize =
        !!read("constructCutList") || !!read("constructGlass");
      setToolBar(_toolbar);
    }
  }, [userData]);

  const handleMenuClose = (event) => {
    if (
      event &&
      anchorRef.current &&
      anchorRef.current.contains(event.target)
    ) {
      return;
    }
    setMenuOpen(false);
  };

  const handleInfoClose = (event) => {
    if (
      event &&
      anchorRef2.current &&
      anchorRef2.current.contains(event.target)
    ) {
      return;
    }
    setInfoOpen(false);
  };

  const handleNavigate = (url) => {
    if (url) {
      push(url);
      handleMenuClose();
      handleInfoClose();
    }
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setMenuOpen(false);
      setInfoOpen(false);
    }
  }

  const handleToggleMenu = () => {
    setMenuOpen(!menuOpen);
    setInfoOpen(false);
  };

  const handleToggleInformation = () => {
    setInfoOpen(!infoOpen);
    setMenuOpen(false);
  };

  const onExit = () => {
    dispatch(logout());
  };

  return (
    <div className={`backMenu rtl-${rtlLayout}`}>
      {toolbar && (
        <>
          {toolbar.dashboard
            .filter((items) => items.menu_title === "buyAccount")
            .filter((items) => items.authorize)
            .filter((items) => items.disabled)
            .filter((items) => items.useAsBeforeButton)
            .map((items) => {
              return (
                <MuiButton
                  key={`before-${items.menu_title}-${items.path || items.action || "item"}`}
                  className="toolbar-menu free-account"
                  title={!loading ? t(items.menu_title) : ""}
                  innerIcon={items.menu_icon}
                  onClick={() => handleNavigate(items.path)}
                  loading={loading}
                />
              );
            })}
          {toolbar.dashboard
            .filter((items) => items.menu_title === "panel_information")
            .filter((items) => items.authorize)
            .map((items) => {
              return (
                <div
                  key={`info-trigger-${items.menu_title}-${items.path || items.action || "item"}`}
                >
                  <MuiButton
                    ref={anchorRef2}
                    className={`toolbar-menu variant-3 ${userData?.panel.remaindays < 3 && "period-warning"}`}
                    aria-controls={infoOpen ? "menu-list-grow" : undefined}
                    aria-haspopup="true"
                    onClick={handleToggleInformation}
                    title={
                      userData?.panel.remaindays
                        ? `${userData?.panel.remaindays.toLocaleString()} ${t("info_RemainDays")}`
                        : "-"
                    }
                    image={!loading && <Icons.HourglassSplit size={17} />}
                    loading={loading}
                    innerIcon={
                      !loading &&
                      (infoOpen ? <Icons.ChevronUp /> : <Icons.ChevronDown />)
                    }
                    size={"large"}
                    variant="contained"
                  />
                  <Popper
                    className="_toolbarMenu mini-information-panel"
                    open={infoOpen}
                    anchorEl={anchorRef2.current}
                    role={undefined}
                    disablePortal
                  >
                    <Paper className="no-padding">
                      <ClickAwayListener onClickAway={handleInfoClose}>
                        <MenuList
                          autoFocusItem={menuOpen}
                          id="menu-list-grow"
                          onKeyDown={handleListKeyDown}
                        >
                          {toolbar.informationPanel
                            .filter((items) => !items.disabled)
                            .map((items) => {
                              return (
                                <div
                                  key={`panel-${items.menu_title}-${items.path || items.key || items.button?.path || "item"}`}
                                  style={{ width: "100%" }}
                                >
                                  {items.needUpDivider && <Divider />}
                                  <MenuItem
                                    onClick={() => handleNavigate(items.path)}
                                    className="mini-information-panel-list-item"
                                  >
                                    <div className="first-items">
                                      {items.menu_icon}
                                      {t(items.menu_title)}
                                    </div>
                                    <div className="second-items">
                                      {items?.key &&
                                        `${userData?.panel[items.key].toLocaleString()} ${t(items.afterKey)}`}
                                      {items?.button && (
                                        <MuiButton
                                          className="toolbar-menu inner-popper"
                                          innerIcon={items.button.icon}
                                          loading={loading}
                                          onClick={() =>
                                            handleNavigate(items.button.path)
                                          }
                                        />
                                      )}
                                    </div>
                                  </MenuItem>
                                  {items.needDownDivider && <Divider />}
                                </div>
                              );
                            })}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Popper>
                </div>
              );
            })}
          <MuiButton
            ref={anchorRef}
            className="toolbar-menu variant-2"
            aria-controls={menuOpen ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            onClick={handleToggleMenu}
            title={userData?.Name.replaceAll(" ", " ")} //alt+0+160
            loading={loading}
            image={
              !loading && (
                <img
                  className="userImg"
                  src={userData?.Logo}
                  alt={userData?.Company}
                />
              )
            }
            innerIcon={
              !loading &&
              (menuOpen ? <Icons.ChevronUp /> : <Icons.ChevronDown />)
            }
            size={"large"}
            variant="contained"
          />
          <Popper
            className="_toolbarMenu profileMenu"
            open={menuOpen}
            anchorEl={anchorRef.current}
            role={undefined}
            disablePortal
          >
            <Paper className="no-padding">
              <ClickAwayListener onClickAway={handleMenuClose}>
                <MenuList
                  autoFocusItem={menuOpen}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                >
                  {toolbar.dashboard
                    .filter((items) => items.authorize)
                    .filter((items) => !items.disabled)
                    .map((items) => {
                      return (
                        <div
                          key={`menu-${items.menu_title}-${items.path || items.action || "item"}`}
                          style={{ width: "100%" }}
                        >
                          {items.needUpDivider && <Divider />}
                          <MenuItem
                            onClick={
                              items.action === "exit"
                                ? onExit
                                : () => handleNavigate(items.path)
                            }
                            className={items.customClass}
                          >
                            {items.menu_icon}
                            <Translator id={items.menu_title} />
                          </MenuItem>
                          {items.needDownDivider && <Divider />}
                        </div>
                      );
                    })}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Popper>
          {toolbar.dashboard
            .filter((items) => items.authorize)
            .filter((items) => items.disabled)
            .filter((items) => items.useAsAfterButton)
            .map((items) => {
              return (
                <MuiButton
                  key={`after-${items.menu_title}-${items.path || items.action || "item"}`}
                  className="toolbar-menu out variant-1"
                  title={!loading ? t(items.menu_title) : ""}
                  innerIcon={items.menu_icon}
                  onClick={() => handleNavigate(items.path)}
                  loading={loading}
                  badge={
                    items.action === "badge"
                      ? notificationCount !== 0
                        ? notificationCount
                        : false
                      : false
                  }
                />
              );
            })}
        </>
      )}
    </div>
  );
}
